<script setup lang="ts">
import { useElementSize } from '@vueuse/core'
import allHistory from './components/all-history.vue'
import currentlyEffect from './components/currently-effect.vue'
import potential from './components/potential.vue'

definePage({
  name: 'transfer-in-out',
  meta: {
    title: '调入调出',
  },
})
const refsList = useTemplateRef('refsList') as any
const refsPageLayout = useTemplateRef('refsPageLayout')
const refTabConten = useTemplateRef('refTabConten')
const { height: tabContenHeight } = useElementSize(refTabConten, undefined, { box: 'border-box' })
const active = ref(0)

const navbarHeight = computed(() => {
  return `${refsPageLayout.value?.navbarHeight || 0}px`
})

const tabsList = ref([
  {
    name: '当前生效',
    val: 0,
  },
  {
    name: '历史所有',
    val: 1,
  },
  {
    name: '潜在调入调出',
    val: 2,
  },
])

const components: any = {
  0: currentlyEffect,
  1: allHistory,
  2: potential,
}

function onTabChange() {
  nextTick(() => {
    if (refsList.value) {
      refsList.value.reLoad()
    }
  })
}
</script>

<template>
  <FmPageLayout ref="refsPageLayout" navbar back class="fluctuation-page">
    <div ref="refTabConten" class="tab-conten" :style="{ top: navbarHeight }">
      <van-tabs v-model:active="active" line-width="9px" @change="onTabChange">
        <van-tab v-for="item in tabsList" :key="item.val" :title="item.name" />
      </van-tabs>
      <van-notice-bar
        left-icon="volume-o"
        color="#333" background="#fff"
        text="港股通共588只，最近调整生效日是2025/12/23"
      />
    </div>
    <div :style="{ height: `${tabContenHeight}px` }" />
    <component :is="components[active]" ref="refsList" />
  </FmPageLayout>
</template>

<style lang="scss" scoped>
.fluctuation-page {
  :deep(.van-tabs__nav) {
    background-color: #f1f2f7;
  }

  :deep(.van-tab--active) {
    font-size: 17px;
  }

  .tab-conten {
    position: fixed;
    left: 0;
    z-index: 2;
    width: 100%;
  }
}
</style>
